import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";

export default class ScatterResult extends SymbolWinResult {
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/results/scatter-result.ts